import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  lang: Cookies.get('lang') || 'zh',
  langs: [
    {
      name: 'zh',
      label: '中文'
    },
    {
      name: 'en',
      label: 'English'
    }
  ],
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  // 语言
  UPDATE_LANG (state, lang) {
    state.lang = lang
    Cookies.set('lang', lang)

  },
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  changeLang ({ commit }, lang) {
    commit('UPDATE_LANG', lang)
  },
}
 // const getters ={
 //   langIndex (state, getters) {
 //     debugger
 //     return state.langs.findIndex(d => d.name === state.lang)
 //   },
 // }

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  // getters,
}
